import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { DEMO_URL, ADMIN_URL } from '../constants';

const LOGO_URL = '/images/logo-matchpool-clear.png';

const Logo = () => (
  <div className="flex items-center">
    <img src={LOGO_URL} alt="MatchPool.live by GOL.SOCIAL"
      className="h-12 w-auto object-contain"
      style={{ maxWidth: '220px' }} />
  </div>
);

const navAnchors = [
  { key: 0, href: '#como-funciona', external: false },
  { key: 1, href: '#para-negocios', external: false },
  { key: 2, href: '#pantalla-tv', external: false },
  { key: 3, href: DEMO_URL, external: true },
  { key: 4, href: ADMIN_URL, external: true },
];

export default function Footer({ onDemoClick }) {
  const { t, lang } = useLanguage();
  const f = t.footer;

  return (
    <footer className="bg-[#0d1117] border-t border-[#0F6B49]/20 py-14" data-testid="footer">
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <Logo />
            </div>
            <p className="text-[#8A9099] text-sm leading-relaxed max-w-xs">{f.tagline}</p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-exo font-bold italic text-[#D5A63B] text-sm uppercase tracking-wider mb-4">Links</h4>
            <ul className="space-y-2.5">
              {f.links.map((link, i) => {
                const a = navAnchors[i] || {};
                return (
                  <li key={i}>
                    <a href={a.href || '#'}
                      {...(a.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      className="text-[#8A9099] hover:text-[#F3F1EB] text-sm transition-colors"
                      data-testid={`footer-link-${i}`}>
                      {link}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-exo font-bold italic text-[#D5A63B] text-sm uppercase tracking-wider mb-4">
              {t.nav.requestDemo}
            </h4>
            <p className="text-[#8A9099] text-sm mb-4">
              {lang === 'es'
                ? 'Activa MatchPool.live en tu negocio hoy.'
                : 'Activate MatchPool.live in your business today.'}
            </p>
            <a href={DEMO_URL} target="_blank" rel="noopener noreferrer"
              className="btn-primary text-sm px-5 py-2.5 no-underline inline-block"
              data-testid="footer-demo-btn">
              {t.nav.requestDemo}
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#0F6B49]/15 pt-6">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <p className="text-[#8A9099] text-xs leading-relaxed max-w-xl">{f.legal}</p>
            <p className="text-[#8A9099] text-xs flex-shrink-0">{f.rights}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
